export const figure28 = { 
    chart: {
        zoomType: 'xy',
        animation: false,
        marginTop: 50,
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'column',
        backgroundColor: 'rgba(255, 255, 255, 0.0)',
        style: {
          fontFamily: 'Montserrat'
        }
      },
      colors: ['#bfbfbf','#ff0000','#00b050'],

      credits: {
        enabled: false
      },
      title: {
        text: null
      },
      subtitle: {
        text: null
      },

      plotOptions: {
        series: {
          borderWidth: 0,
          stacking: 'normal',
          },
          column: {
              stacking: 'percent'
          }
      },
  
      exporting: {
        enabled: false
      },
  
  
      xAxis: [{
        categories: [ "أفريقيا جنوب الصحراء", "أوقيانوسيا (باستثناء أستراليا ونيوزيلندا)", "آسيا الوسطى وجنوب آسيا", "شمال أفريقيا وغرب آسيا", "أمريكا اللاتينية ومنطقة البحر الكاريبي", "شرق آسيا وجنوب شرق آسيا", "أوروبا وأمريكا الشمالية", "أستراليا ونيوزيلندا", "العالم"],
        lineColor: "#d7d7d7",
        tickColor: "#d7d7d7",
        tickLength: 16,
        labels: {
          style: {
            fontWeight: 'normal',
            color: '#999999',
	    fontSize: '12px',
	    textOverflow: 'none',
          }
        },
      }],
      yAxis: {
	min: 0,
	max: 100,
	tickInterval: 20,	
        title: {
            text: ''
        }
    },
    tooltip: {
	    pointFormat: '<b>{point.y} ({point.percentage:.0f}%) </b>:<span style="color:{series.color}">{series.name}</span> <br/>',
        shared: true
    },
    legend: {
        enabled: false,
      },
 
      series: [
        {
            name: 'السلالات المحلية ذات حالة الخطر غير المعروفة',
            color: '#bfbfbf',
            data: [ 659, 64, 558, 412, 472, 992, 1213, 24, 4394 ]
        },
	{
		name: 'السلالات المحلية غير المعرضة للخطر',
		      color: '#ff0c00',
		      data: [37, 0, 34, 21, 37, 53, 1631, 58, 1871]
	},
	{
          name: 'السلالات المحلية المعرضة للخطر',
          color: '#0eb050',
		data: [ 78, 0, 151, 65, 59, 88, 353, 9, 803 ]
	},
       
      ]
}
